import React, {Component} from 'react';
import Title from '../base/title';
import Dropdown from '../base/dropdown';
import RadioGroup from '../base/radiogroup';
import api from '../../utils/api';

const ReactHighcharts = require('react-highcharts');

const defaultConf = {
  chart: {
    type: 'column'
  },
  title: {
    text: null
  },
  credits: {
      enabled: false
  },
  legend: {
    enabled: false
  },
  xAxis: {},
  yAxis: {
    allowDecimals: false,
    min: 0,
    max: 100, 
    minRange: 5,
    title: {
      text: null
    },
    labels: {
      format: '{value}%'
    }
  },
  tooltip: {
    pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
    shared: true
  },
  plotOptions: {
    column: {
        animation: false,
      stacking: 'percent'
    }
  }
};

export default class MarketShare extends Component {

  constructor(props) {
    super(props);
    this.state = {
      opened: true,
      loader: ' loader-box',
      products: [],
      flags: [],
      month: {},
      months: [{ id:0, label: '' }],
      product: [],
      flag: [],
      series: {},
      chartAvailable: true
    };
    this.state.chart = defaultConf;
    this.getMonth = this.getMonth.bind(this);
    this.getProducts = this.getProducts.bind(this);
    this.getFlag = this.getFlag.bind(this);
    this.redraw = this.redraw.bind(this);
    this.loadChart = this.loadChart.bind(this);
  }

  loadChart(product_list, time) {
    let _self = this;
    let url = 'widgets/market-share/?type=' + this.props.level + '&id=' + this.props.id + '&' + product_list.join('&');
    if (!time) time = 'M12';

    url += '&time_reference=' + time;
    api.get(url, true).then(resp => {
      let series = {}
      resp.data.series.forEach(serie => {
        if (serie.name.indexOf('SHELL') >= 0) {
          series['SHELL'] = { 
            data: serie.data,
            name: serie.name,
            color: serie.color,
            stack: 'stack',
            borderWidth: 0
          }
        } else if (serie.name.indexOf('YPF') >= 0) {
          series['YPF'] = { 
            data: serie.data,
            name: serie.name,
            color: serie.color,
            stack: 'stack',
            borderWidth: 0
          }
        } else if (serie.name.indexOf('AXION') >= 0) {
          series['AXION'] = { 
            data: serie.data,
            color: serie.color,
            name: serie.name,
            stack: 'stack',
            borderWidth: 0
          }
        } else if (serie.name.indexOf('PETROBRAS') >= 0) {
          series['PETROBRAS'] = { 
            data: serie.data,
            name: serie.name,
            color: serie.color,
            stack: 'stack',
            borderWidth: 0
          }
        } else {
          series['OTRAS'] = { 
            data: serie.data,
            name: serie.name,
            color: serie.color,
            stack: 'stack',
            borderWidth: 0
          }
        }
      });

      defaultConf.xAxis.categories = resp.data.categories;
      defaultConf.colors = [series.SHELL.color, series.YPF.color, series.AXION.color, series.PETROBRAS.color, series.OTRAS.color];
      defaultConf.series = [series.SHELL, series.YPF, series.AXION, series.PETROBRAS, series.OTRAS];
      if (this.props.static) {
        defaultConf.plotOptions.series = {
          animation: false
        }
      }

      if (_self._ismounted) {
        _self.setState({
          chart: defaultConf,
          series: series,
          flags: [
            { id: 1, label: "SHELL", color: series.SHELL.color, active: true },
            { id: 2, label: "YPF", color: series.YPF.color, active: true  },
            { id: 3, label: "AXION", color: series.AXION.color, active: true  },
            { id: 4, label: "PETROBRAS", color: series.PETROBRAS.color, active: true  },
            { id: 5, label: "OTRAS", color: series.OTRAS.color, active: true  },
          ],
          loader: '',
          chartAvailable: true
        });

        _self.refs.flags.update();
        _self.refs.products.update();

        _self.redraw();
      }
    });
  }

  componentWillUnmount() {
   this._ismounted = false;
  }

  componentDidMount() {
    this._ismounted = true;
    let _self = this;
    if (!this.state.opened) return;
    api.get('filters/products').then(resp => {
      let product_list = [];
      let products = [];
      resp.data.forEach(prod => {
        products.push({ id: prod.id, label: prod.short_name, active: true });
        product_list.push('product_list=' + prod.id);
      });

      api.get('filters/time-range/?widget=market-share').then(resp => {
        let months = [{ id: 0, label: "SELECCIONAR" }];
        resp.data.forEach(time => {
          months.push({label: time.description, id: time.id})
        });
        if (_self._ismounted) {
          _self.setState({
            month: months[1],
            months: months,
            products: products,
            product: products,
            flag: [
              { id: 1, label: "SHELL", active: true },
              { id: 2, label: "YPF", active: true  },
              { id: 3, label: "AXION", active: true  },
              { id: 4, label: "PETROBRAS", active: true  },
              { id: 5, label: "OTRAS", active: true  }
            ]
          }, function() {
            _self.refs.flags.update();
            _self.refs.products.update();
            _self.refs.month.update(months[1]);
            _self.loadChart(product_list);
          });
        }
      });
    });
  }

  getMonth(item) {
    this.setState({ month: item, chartAvailable: false}, function() {
      let product_list = [];
      this.state.product.forEach(prod => {
        product_list.push('product_list=' + prod.id);
      });
      this.loadChart(product_list, item.id);
    });
  }

  getProducts(item) {
    this.setState({ product: item, chartAvailable: false}, function() {
      let product_list = [];
      this.state.product.forEach(prod => {
        product_list.push('product_list=' + prod.id);
      });
      this.loadChart(product_list, this.state.month.id);
    });
  }

  getFlag(item) {
    this.setState({ flag: item }, function() {
      this.redraw();
    })
  }

  redraw() {
    let _self = this;
    if (_self.refs.chart) {
      let chart = _self.refs.chart.getChart();
      var seriesLength = chart.series.length;
      for(let i = seriesLength -1; i > -1; i--) {
          chart.series[i].remove();
      }
      _self.state.flag.forEach(flag => {
        chart.addSeries(_self.state.series[flag.label]);
      });
    }
  }

  render() {
    let _self = this;
    return <div className="row">
        <Title isOpen={_self.state.opened} toggle={() => { _self.setState({ opened: !_self.state.opened }, function() { if (_self.state.opened) _self.componentDidMount(); }); }} text="MARKET SHARE" isGray={true} hasIcon={true} />
        {this.state.opened && <div className="row">
          <div className="col s12">
            <div className="row">
              <div className={"marketShare" + this.state.loader}>
                <div className="row">
                  <div className="col s3 no-gutter">
                    <Dropdown ref="month" text='PERIODO:&nbsp;&nbsp;&nbsp;' items={this.state.months}  getItem={this.getMonth} />
                  </div>
                  <div className="col s4 no-gutter">
                    <RadioGroup ref="products" text='PRODUCTO:' items={this.state.products}  getItem={this.getProducts} />
                  </div>
                  <div className="col s5 no-gutter">
                    <RadioGroup ref="flags" text='BANDERA:' items={this.state.flags}  getItem={this.getFlag} />
                  </div>
                </div>
                <div>
                  <div className={this.state.chartAvailable ? "chartContainer" : "chartContainer loader"}>
                    <ReactHighcharts config={this.state.chart} ref="chart" />
                  </div>    
                </div>
              </div>
            </div>
          </div>
        </div>}
      </div>
  }

}


// WEBPACK FOOTER //
// ./src/containers/analisis/marketsharecluster.js